import { createRoutine } from 'redux-saga-routines'

export const SET = 'USER/SET'
export const LOGOUT = 'USER/LOGOUT'
export const LOGIN = createRoutine('USER/LOGIN')
